// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container___UABJb{display:inline-block}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/routes/TenantGroup/components/TenantGroupRulesTable/SplitViewContent/TenantGroupOverridePaper/EditOverrideBtn/EditOverrideBtn.css"],"names":[],"mappings":"AAAA,mBACI,oBAAA","sourcesContent":[".container {\n    display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container___UABJb"
};
export default ___CSS_LOADER_EXPORT___;
